import { render, staticRenderFns } from "./collectionPerformanceDetails.vue?vue&type=template&id=7bdedee4&scoped=true&"
import script from "./collectionPerformanceDetails.vue?vue&type=script&lang=ts&"
export * from "./collectionPerformanceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./collectionPerformanceDetails.vue?vue&type=style&index=0&id=7bdedee4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdedee4",
  null
  
)

export default component.exports